import React from 'react';
import { Form, Input, Button, message, Row, Col, Modal, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { updateUser } from '../ProfileServices';
import { useGlobal } from '../../Shared/GlobalContext/GlobalContext';

const EditProfile = ({ handleClose, user, fetchUser }) => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const { loading, setLoading } = useGlobal();

    const handleSubmit = async () => {
        try {
            setLoading(true);
            await updateUser({
                first_name: form.getFieldValue('first_name'),
                last_name: form.getFieldValue('last_name'),
                email: form.getFieldValue('email'),
                gender: form.getFieldValue('gender'),
            });
            fetchUser();
            handleClose();
        } catch (error) {
            message.error(t('error_updating_profile'));
        } finally {
            setLoading(false);
        }
    };
    return (
        <Modal
            title={<p style={{ marginTop: 0 }}>{t('edit_profile')}</p>}
            footer={
                <Button size="medium" type="primary" block loading={loading}
                    onClick={handleSubmit}>
                    {t('save_changes')}
                </Button>
            }
            open
            onCancel={handleClose}
        >
            <Form
                form={form}
                layout="vertical"
                initialValues={{
                    first_name: user?.first_name,
                    last_name: user?.last_name,
                    email: user?.email,
                    gender: user?.gender,
                }}
            >
                <Row gutter={[24, 0]} style={{ margin: 0 }}>
                    <Col xs={24} md={12}>
                        <Form.Item
                            name="first_name"
                            label={t('first_name')}
                            rules={[{ required: true, message: t('first_name_is_required') }]}
                        >
                            <Input size="medium" />
                        </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                        <Form.Item
                            name="last_name"
                            label={t('last_name')}
                            rules={[{ required: true, message: t('last_name_is_required') }]}
                        >
                            <Input size="medium" />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            name="email"
                            label={t('email_address')}
                            rules={[
                                { required: true, message: t('email_is_required') },
                                { type: 'email', message: t('please_enter_a_valid_email') }
                            ]}
                        >
                            <Input size="medium" />
                        </Form.Item>
                    </Col>
                    
                    <Col span={12}>
                        <Form.Item
                            name="gender"
                            label={t('gender')}
                            rules={[{ required: true, message: t('gender_is_required') }]}
                        >
                            <Select size="medium">
                                <Select.Option value="male">{t('male')}</Select.Option>
                                <Select.Option value="female">{t('female')}</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default EditProfile;
